import React from 'react';

import Menu from '@/layout/components/DealerWebHeader/components/Menu';

import Dropdown from '../Dropdown';

import { LinkDropdownProps } from './types';

function LinkDropdown({
  label,
  link,
  isNewTab,
  menu,
  onClick,
}: LinkDropdownProps) {
  return (
    <Dropdown label={label} link={link} isNewTab={isNewTab} onClick={onClick}>
      <Menu menu={menu} />
    </Dropdown>
  );
}

export default LinkDropdown;
